// extracted by mini-css-extract-plugin
module.exports = {"modal__alert":"Alert_modal__alert_1VE2F","modal__alertText":"Alert_modal__alertText_2n9wn","modal__alertButton":"Alert_modal__alertButton_V5bNg"};